<script setup lang="ts">
const { $containment } = useNuxtApp();

function onModalClose() {
  $containment.closeVerificationModal();
}

// Active or disable the verification debug
const activeVerificationDebug = ref(true);

const isVerificationDebugVisible = computed(() => {
  return $containment.isVerificationModalOpen && activeVerificationDebug.value;
});
</script>

<template>
  <BaseModal
    :custom-class-wrapper="$style.verificationModal"
    :model-value="$containment.isVerificationModalOpen"
    persistent
    @close="onModalClose"
  >
    <AuthVerification />
  </BaseModal>

  <DevOnly v-if="isVerificationDebugVisible">
    <AuthVerificationDebug />
  </DevOnly>
</template>

<style module lang="postcss">
.verificationModal {
  @apply p-0;
}
</style>
